import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

type UseCommentsOpenStateProps = {
  type?: 'album' | 'photo'
  initialOpenState?: boolean
}

export function useCommentsOpenState({
  type = 'photo',
  initialOpenState = false,
}: UseCommentsOpenStateProps = {}) {
  const [search, setSearch] = useSearchParams()
  const commentSearchParam =
    type === 'album' ? search.get('albumComment') : search.get('photoComment')
  const [commentsDrawerOpen, setCommentsDrawerOpen] = useState(
    Boolean(commentSearchParam) || initialOpenState,
  )
  useEffect(() => {
    if (commentSearchParam) {
      setCommentsDrawerOpen(true)
      const timeout = window.setTimeout(() => {
        setSearch(undefined, {
          replace: true,
        })
      }, 3000)
      return () => {
        window.clearTimeout(timeout)
      }
    }
  }, [commentSearchParam, setSearch])
  return [commentsDrawerOpen, setCommentsDrawerOpen] as const
}
